export default function (router) {
    router.push(
        {
            path: '/mobile',
            redirect: '/mobile/index'
        },
        {
            path: '/mobile/index',
            children: [
                {
                    path: '/',
                    meta: {
                        title: '莹木智联监测平台',
                        requireAuth: true
                    },
                    component: () => (import("@/components/mobile/ammeter")),
                },
                {
                    path: '/mobile/ammeter',
                    name:'mobileAmmeter',
                    meta: {
                        title: '莹木智联监测平台',
                        requireAuth: true
                    },
                    component: () => (import("@/components/mobile/ammeter")),
                },
                {
                    path: '/mobile/ammeterDetails',
                    name: 'mobileAmmeterDetails',
                    meta: {
                        title: '莹木智联监测平台',
                        requireAuth: true
                    },
                    component: () => (import("@/components/mobile/ammeterDetails")),
                },
                {
                    path: '/mobile/lampList',
                    name: 'mobileLampList',
                    meta: {
                        title: '莹木智联监测平台',
                        requireAuth: true
                    },
                    component: () => (import("@/components/mobile/lampList")),
                },
            ],
            component: () => import("@/components/mobile/index.vue")
        },
        {
            path: '/mobile/login',
            name: 'mobilelogin',
            meta: {
                title: '登录',
                requireAuth: false
            },
            component: () => import("@/components/mobile/login.vue")
        }
    )
}


// WEBPACK FOOTER //
// ./src/router/modules/mobile.js